import { ReloadOutlined } from "@ant-design/icons";
import { Button, Flex, Typography } from "antd";
import { FC } from "react";

import { StyledDashboardInfoBlock, StyledDashboardInfoIcon } from "./Styled";

interface IDashboardInfoBlock {
    title: string;
    onClickReload?: () => void;
}

export const DashboardInfoBlock: FC<IDashboardInfoBlock> = ({
    title,
    onClickReload,
}) => {
    return (
        <StyledDashboardInfoBlock>
            <Flex gap={8} align="center">
                <StyledDashboardInfoIcon />
                <Typography dangerouslySetInnerHTML={{ __html: title }} />
            </Flex>

            {onClickReload && (
                <Button
                    type="text"
                    shape="circle"
                    icon={<ReloadOutlined />}
                    onClick={onClickReload}
                />
            )}
        </StyledDashboardInfoBlock>
    );
};
